// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gas-item {\n  padding-top: 18px !important;\n}\n.gas-item .q-field__inner {\n  padding-bottom: 0px !important;\n}\n.gas-item .customText {\n  padding-bottom: 0px !important;\n}\n.gas-card-title {\n  font-size: 15px;\n  font-weight: 800;\n}\n.workpermit-worker-info {\n  margin-left: 0.5em !important;\n  margin-right: 0 !important;\n}\n.workpermit-worker-info .q-avatar__content {\n  font-size: 0.8em;\n  line-height: 0.8em;\n}", ""]);
// Exports
module.exports = exports;
